import axios from "axios";
import { serviceTypes } from "./Types";
import {
  GATEWAY_SERVICE,
  LIBRARY_SERVICE,
  NOTIFICATION_SERVICE,
  RECOMMENDATION_SERVICE,
  REDIRECT_URI,
  USERPLAN_SERVICE,
  USER_SERVICE
} from "./URLConstants";

export let instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export function getServiceType(service?: string) {
  switch (service) {
    case serviceTypes.recommendation:
      return RECOMMENDATION_SERVICE;

    case serviceTypes.userplan:
      return USERPLAN_SERVICE;

    case serviceTypes.user:
      return USER_SERVICE;

    case serviceTypes.notification:
      return NOTIFICATION_SERVICE;
    case serviceTypes.gateWay:
      return GATEWAY_SERVICE;

    default:
      return LIBRARY_SERVICE;
  }
}

export const axiosGet = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.get(`${getServiceType(service)}${url}`, {
      params
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosPost = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.post(`${getServiceType(service)}${url}`, params, {});
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosPatch = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.patch(`${getServiceType(service)}${url}`, params, {});
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosDelete = async (url: string, service?: string, params?: any, data?: any) => {
  try {
    const response = await instance.delete(`${getServiceType(service)}${url}`, {
      data,
      params
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosPostToken = async (url: string | undefined, code?: string) => {
  const params = code
    ? {
        code,
        grant_type: process.env.REACT_APP_GRANT_TYPE,
        redirect_uri: REDIRECT_URI
      }
    : {
        grant_type: "refresh_token",
        refresh_token: localStorage.getItem("refresh_token"),
        redirect_uri: REDIRECT_URI
      };

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded"
  };

  try {
    const response = await instance.post(`${url}`, params, { headers });
    return response;
  } catch (error) {
    return error;
  }
};

export const axiosPut = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.put(`${getServiceType(service)}${url}`, params, {});
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosFileUpload = async (url: string, service?: string, payload?: any) => {
  try {
    const response = await instance.post(`${getServiceType(service)}${url}`, payload, {
      headers: {
        accept: "application/json",
        "Content-Type": "multipart/form-data"
      }
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosFileDownload = async (url: string, service?: string) => {
  try {
    const response = await instance.get(`${getServiceType(service)}${url}`, {
      headers: {
        accessRole: "ADMIN",
        accept: "application/octet-stream"
      },
      responseType: "blob"
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosPostFileDownload = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.post(`${getServiceType(service)}${url}`, params, {
      responseType: "blob"
    });
    return response;
  } catch (error: any) {
    return error;
  }
};
